import React from 'react'

import { ContentType } from './content.types'
import {
  ContentBanner,
  ContentBody,
  ContentHead,
  ContentWrapper
} from './index'

type ContentPropsType = {
  children?: React.ReactNode
  className?: string
} & ContentType

export const Content = ({
  children,
  category,
  bannerSrc,
  author,
  content,
  title,
  className
}: ContentPropsType) => {
  return (
    <ContentWrapper className={className}>
      {bannerSrc && <ContentBanner src={bannerSrc || ''} />}
      <div className="flex flex-col gap-2 p-2 sm:p-4">
        <ContentHead
          author={author || ''}
          category={category || ''}
          title={title || ''}
        />
        <ContentBody content={content || ''} />
        {children}
      </div>
    </ContentWrapper>
  )
}
